import type { SegmentPickerTab } from './SegmentPickerTabs';

/** DOM id of a segment picker tab, referenced by the tab panel's `aria-labelledby`. */
export function getSegmentPickerTabId(pickerId: string, tab: SegmentPickerTab): string {
  return `${pickerId}-${tab}-tab`;
}

/** DOM id of a segment picker's tab panel, referenced by each tab's `aria-controls`. */
export function getSegmentPickerPanelId(pickerId: string): string {
  return `${pickerId}-panel`;
}
